import { render, staticRenderFns } from "./BuyGame.vue?vue&type=template&id=7a2bcd01&scoped=true&lang=pug&"
import script from "./BuyGame.vue?vue&type=script&lang=js&"
export * from "./BuyGame.vue?vue&type=script&lang=js&"
import style0 from "./BuyGame.vue?vue&type=style&index=0&id=7a2bcd01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2bcd01",
  null
  
)

export default component.exports